/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskFeedback } from './taskFeedback';

export type OralExamSubmissionEvaluationOverallFeedback = TaskFeedback | null;
